/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getPayModeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetPayModeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getPayModeByIdIdRegExpTwo)]).optional()
});

export type GetPayModeById = zod.input<typeof GetPayModeById>;
export type GetPayModeByIdOutput = zod.output<typeof GetPayModeById>;
